<section class="header-btn-wrapper">
    <button nz-button nzType="primary" (click)="showItem()">Create Streaming Event</button>
</section>
<app-search-form #SearchForm [searchSection]="searchSection" (searchCriteria)="setSearchCriteria($event)"></app-search-form>

<ag-grid-angular #agGrid class="ag-theme-alpine" [gridOptions]="gridOptions" [columnDefs]="columnDefs"
    rowSelection="multiple" [defaultColDef]="defaultColDef" [pagination]="true" [suppressRowClickSelection]="true"
    (gridReady)="onGridReady($event)" [enableCellTextSelection]="true" (sortChanged)="sortChanged($event)"
    style="height: 70vh">
</ag-grid-angular>